
import GridFeaturedItem from "@/components/Grids/GridFeatured/GridFeaturedItem.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    GridFeaturedItem,
  },
  props: {
    categories: Object,
  },
});
